import { render, staticRenderFns } from "./AppInfo.vue?vue&type=template&id=42cb4f34&scoped=true&"
import script from "./AppInfo.vue?vue&type=script&lang=js&"
export * from "./AppInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppInfo.vue?vue&type=style&index=0&id=42cb4f34&prod&lang=scss&"
import style1 from "./AppInfo.vue?vue&type=style&index=1&id=42cb4f34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb4f34",
  null
  
)

export default component.exports